export const KEY_REMEMBER_ME = "huellaCarbono.rememberMe";
